import _slicedToArray from "/vercel/path0/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { produce as t } from "immer";
import { atom as o } from "jotai/vanilla";
import { useCallback as r } from "react";
import { useAtom as n } from "jotai/react";
function e(r) {
  var n = o(r, function (o, r, e) {
    return r(n, t(o(n), "function" == typeof e ? e : function () {
      return e;
    }));
  });
  return n;
}
var i = new WeakMap();
function f(r) {
  return n = function n() {
    return o(function (t) {
      return t(r);
    }, function (o, n, e) {
      return n(r, t(o(r), "function" == typeof e ? e : function () {
        return e;
      }));
    });
  }, (i.has(e = r) ? i : i.set(e, n())).get(e);
  var n, e;
}
function a(o, e) {
  var _n = n(o, e),
    _n2 = _slicedToArray(_n, 2),
    i = _n2[0],
    f = _n2[1];
  return [i, r(function (o) {
    return f(t(o));
  }, [f])];
}
export { e as atomWithImmer, a as useImmerAtom, f as withImmer };